'use client';

import dynamic from 'next/dynamic';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import logTrailDetailsActionTapped from '@alltrails/amplitude/events/logTrailDetailsActionTapped';
import useUser from '@alltrails/context/hooks/useUser';
import Button from '@alltrails/denali/components/Button';
import { getTrailDirectionsUrl } from '@alltrails/trails';
import type TrailDetails from '@alltrails/types/TrailDetails';

const SignUpModal = dynamic(() => import('@alltrails/user-auth/components/SignUpModal'), { ssr: false });

type Props = {
  trailDetails: TrailDetails;
};

export default function DirectionsButton({ trailDetails }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const user = useUser();

  const latitude = trailDetails.location?.latitude;
  const longitude = trailDetails.location?.longitude;

  const url = getTrailDirectionsUrl(latitude, longitude);

  return (
    <>
      <Button
        disabled={!latitude || !longitude}
        onClick={() => {
          logTrailDetailsActionTapped({
            trail_id: trailDetails.id.toString(),
            trail_page_action: 'get directions',
            trail_page_location: 'mobile view',
            trail_page_type: 'trail detail page'
          });

          if (!user) {
            setIsOpen(true);
            return;
          }

          window.open(url, '_blank', 'noopener noreferrer');
        }}
        text={<FormattedMessage defaultMessage="Get directions" />}
        width="full"
      />
      {isOpen && (
        <SignUpModal
          closeModal={() => setIsOpen(false)}
          deeplinkData={{ pageId: trailDetails.id, pageType: 'trail' }}
          isOpen={isOpen}
          onSuccess={() => {
            setIsOpen(false);
            window.open(url, '_blank', 'noopener noreferrer');
          }}
          trigger="Trail Detail Directions"
          upsellTrigger="Trail Detail Directions"
        />
      )}
    </>
  );
}
